import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import type { PasteSummary } from '@personalizehq/editor';

export function PasteReviewDialog({
  open,
  summary,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  summary: PasteSummary | null;
  onCancel: () => void;
  onConfirm: () => void;
}): React.JSX.Element {
  const rows = [
    ...(summary?.importedTokens.map((token) => `Import ${token}`) ?? []),
    ...(summary?.renamedTokens.map(({ from, to }) => `Rename ${from} → ${to}`) ?? []),
    ...(summary?.repairs ?? []),
  ];
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onCancel(); }}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Review pasted dependencies</DialogTitle>
          <DialogDescription>The copied components need these safe imports or repairs before they can be added.</DialogDescription>
        </DialogHeader>
        <ul className="max-h-64 list-disc space-y-1 overflow-y-auto pl-5 text-xs text-muted-foreground">
          {rows.map((row) => <li key={row}>{row}</li>)}
        </ul>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>Cancel</Button>
          <Button onClick={onConfirm}>Paste components</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
